import React, { useState } from "react";
import "../Petunjuk/Petunjuk.css";
import dataSlider from "./dataSlider";
import Btnslider from "./Btnslider";
import { NavLink } from "react-router-dom";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
const Petunjuk = () => {
	const [slideIndex, setSlideIndex] = useState(1);

	const nextSlide = () => {
		if (slideIndex !== dataSlider.length) {
			setSlideIndex(slideIndex + 1);
		} else if (slideIndex === dataSlider.length) {
			setSlideIndex(1);
		}
	};

	const prevSlide = () => {
		if (slideIndex !== 1) {
			setSlideIndex(slideIndex - 1);
		} else if (slideIndex === 1) {
			setSlideIndex(dataSlider.length);
		}
	};

	const moveDot = (index) => {
		setSlideIndex(index);
	};

	return (
		<div>
			<div className="container-slider">
				{dataSlider.map((obj, index) => {
					return (
						<div
							key={obj.id}
							className={
								slideIndex === index + 1 ? "slide active-anim" : "slide"
							}
						>
							<TransformWrapper defaultScale={1}>
								<TransformComponent>
									<img
										alt="petunjuk"
										src={
											process.env.PUBLIC_URL + `/img/petunjuk/${index + 1}.png`
										}
									/>
								</TransformComponent>
							</TransformWrapper>
						</div>
						
					);
				})}
							<Btnslider moveSlide={nextSlide} direction={"next"} />
						<Btnslider moveSlide={prevSlide} direction={"prev"} />

				<div className="container-dots">
					{Array.from({ length: 8 }).map((item, index) => (
						<div
							onClick={() => moveDot(index + 1)}
							className={slideIndex === index + 1 ? "dot active" : "dot"}
						></div>
					))}
						
				</div>
			</div>
			<div className="d-flex justify-content-center mt-3">

				<NavLink style={{ textDecoration: "none" }} to="/">
					<button className="btn btn-outline-success">Kembali</button>
				</NavLink>
			</div>
		</div>
	);
};

export default Petunjuk;
